<template>
  <div>
    <p>
      <el-input v-model="name" size="small" placeholder="请输入内容" style="width:400px;margin-right:10px;" />
      <el-button size="mini" icon="el-icon-plus" type="success" style="width:80px;" @click="addBtn">新增</el-button>
    </p>
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="small">
      <el-table-column width="100" type="index" label="序号" />

      <el-table-column min-width="200px" label="交付件类型">
        <template slot-scope="scope">
          <template v-if="scope.row.edit">
            <el-input v-model="scope.row.name" class="edit-input" size="small" />
            <el-button
              class="cancel-btn"
              size="mini"
              icon="el-icon-refresh"
              type="warning"
              @click="cancelEdit(scope.row)">取消</el-button>
          </template>
          <span v-else>{{ scope.row.originalTitle }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="creator_name" label="创建人" />
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="handleClick(scope.row)">编辑</el-button> -->
          <el-button
            v-if="scope.row.edit"
            type="primary"
            size="mini"
            @click="confirmEdit(scope.row)">保存</el-button>
          <el-button v-else type="success" size="mini" @click="scope.row.edit=!scope.row.edit">编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
// import { getUserInfoByIdList } from '@/api/login'
import { searchType, addType, editType } from '@/api/deliver'
export default {
  data() {
    return {
      name: '',
      tableData: [],
      multipleSelection: [],
      form: { page_size: 1000, page: 1 }
    }
  },
  created() {
    this.getTypeList()
  },
  methods: {
    getTypeList() {
      searchType(this.form).then(response3 => {
        if (response3.code === 'success') {
          if (response3.data.types) {
            const responseData = response3.data.types

            for (const i in responseData) {
              this.$set(responseData[i], 'edit', false) // https://vuejs.org/v2/guide/reactivity.html
              responseData[i].originalTitle = responseData[i].name
            }

            this.tableData = responseData
          } else {
            this.tableData = []
          }
        } else {
          this.errMsg()
        }
      }).catch()
    },
    // 增加会议类型
    addBtn() {
      if (this.name !== '') {
        addType(this.name).then(response2 => {
          if (response2.code === 'success') {
            this.successMsg()
            this.getTypeList()
          } else {
            this.errMsg()
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$message.warning('请先输入内容后点击新增')
      }
    },

    // 编辑
    cancelEdit(row) {
      row.name = row.originalTitle
      row.edit = false
      this.$message({
        message: '已取消修改',
        type: 'warning'
      })
    },
    confirmEdit(row) {
      editType(row.id, row.name).then(res => {
        if (res.code === 'success') {
          row.edit = false
          row.originalTitle = row.name
          this.$message({
            message: '保存成功',
            type: 'success'
          })
        } else {
          row.edit = true
          row.name = row.originalTitle
        }
      }).catch(err => { console.log(err) })
    },
    successMsg() {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    errMsg() {
      this.$message({
        message: '操作失败',
        type: 'error'
      })
    }

  }
}
</script>

<style scoped>
  .edit-input {
    padding-right: 100px;
  }

  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>
